<template>
  <starter-template
    v-if="mode === 'create'"
    @cancel="$router.push('/user/starter-template')"
    @submit="$router.push('/user/starter-template')"
  ></starter-template>
  <starter-template
    v-else-if="mode === 'edit'"
    :id="$route.params.id"
    @cancel="$router.push('/user/starter-template')"
    @submit="$router.push('/user/starter-template')"
  ></starter-template>
  <v-container v-else fluid fill-height>
    <v-layout justify-center>
      <v-flex xs12>
        <starter-template-list
          show-broken
          actions
          :rules="'sdf-2021'"
        ></starter-template-list>
      </v-flex>

      <v-tooltip left>
        <v-btn
          color="red"
          dark
          fixed
          bottom
          right
          fab
          :disabled="dancers.items.length === 0"
          slot="activator"
          @click="$router.push('/user/starter-template/create')"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Neuer Starter</span>
      </v-tooltip>
    </v-layout>
  </v-container>
</template>

<script>
import StarterTemplate from "../../components/user/StarterTemplate";
import StarterTemplateList from "../../components/user/StarterTemplateList";
import { mapState } from "vuex";

export default {
  components: {
    StarterTemplate,
    StarterTemplateList
  },
  data: () => ({
    mode: "default"
  }),
  computed: {
    ...mapState(["dancers"])
  },
  beforeRouteLeave(to, from, next) {
    this.checkMode(to.path);

    next();
  },
  mounted() {
    this.checkMode(this.$router.currentRoute.path);
  },
  methods: {
    checkMode(path) {
      if (path.endsWith("/create")) {
        this.mode = "create";
      } else if (path.includes("/edit")) {
        this.mode = "edit";
      } else {
        this.mode = "default";
      }
    }
  }
};
</script>
